import React from "react";
import { OptionCard } from "./OptionCard";

export const CheckboxField = ({ question, value, onChange, lang }) => {
  const selected = Array.isArray(value) ? value : [];
  const opts = question.options || [];
  if (!opts.length) return <div className="dq-empty">No options configured.</div>;
  const toggle = (id) => {
    if (selected.includes(id)) onChange(selected.filter((x) => x !== id));
    else onChange([...selected, id]);
  };
  const qStyle = question.config && question.config.option_style;
  const useGrid =
    !qStyle || (qStyle !== "compact" && qStyle !== "icon");
  return (
    <div
      className={useGrid ? "dq-options" : ""}
      style={
        useGrid
          ? undefined
          : {
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
              justifyContent: "center",
            }
      }
    >
      {opts.map((opt) => (
        <OptionCard
          key={opt.id}
          option={opt}
          selected={selected.includes(opt.id)}
          onClick={() => toggle(opt.id)}
          lang={lang}
          questionStyle={qStyle}
        />
      ))}
    </div>
  );
};
